{
    "navbar": {
        "help_center": "Hilfe",
        "share_idea": "Eine Idee mitteilen",
        "logout": "Abmelden"
    },
    "languages": {
        "title": "Sprachen",
        "explanation": "Sie können die Benutzersprache von Koobi zu einer der folgenden Sprachen ändern",
        "de": "Deutsch",
        "fr": "Französisch",
        "en": "Englisch",
        "it": "Italienisch",
        "es": "Spanisch"
    },
    "form": {
        "submit": "Bestätigen",
        "cancel": "Abbrechen",
        "errors": {
            "required": "Dies ist ein Pflichtfeld"
        }
    },
    "menu": {
        "request_manager": {
            "title": "Request Manager",
            "pipeline": "Pipeline",
            "todo": "To Do",
            "inbox": "Inbox",
            "message_templates": "Message Templates"
        },
        "offer_manager": {
            "title": "Offer Manager",
            "itineraries": "Online-Reisepläne"
        },
        "cash_manager": {
            "title": "Cash Manager",
            "accounting": "Buchhaltung"
        },
        "insights": {
            "title": "Insights",
            "statistics": "Statistiken",
            "customer_satisfaction": "Kundenzufriedenheit",
            "better_trip_index": "Better Trip Index"
        },
        "tipi": {
            "title": "Trip Planner",
            "library": "Bibliothek"
        },
        "tools": {
            "title": "Resources Center",
            "partner_connect": "Partner Connect"
        },
        "agency_manager": {
            "title": "Agency Manager",
            "main_contacts": "Hauptkontakte",
            "active_accounts": "Aktive Konten",
            "agency_capacity": "Kapazität der Agentur",
            "legal_information": "Rechtliche Informationen"
        }
    }
}
